import { render, staticRenderFns } from "./FormForms.vue?vue&type=template&id=149eda26&scoped=true"
import script from "./FormForms.vue?vue&type=script&lang=js"
export * from "./FormForms.vue?vue&type=script&lang=js"
import style0 from "./FormForms.vue?vue&type=style&index=0&id=149eda26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149eda26",
  null
  
)

export default component.exports